import { isVideo } from "@/utils/utils";
import QrCode from "qrcode";
import requestApi from "@/utils/requestApi";

let imgTransferTimer = null;

export default {
  props: {
    limit: {
      type: Number,
      default: 6,
    },
    list: {
      type: Array,
      default: [],
      require: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    uploadId: "",
  },
  watch: {
    mobUploadVisible(val) {
      if (!val) {
        imgTransferTimer && clearInterval(imgTransferTimer);
        requestApi.post(`${process.env.VUE_APP_APITAAS}scbasic/system/redis/del`, {
          key: this.uploadId,
        });
      }
    },
    fileList(arr) {
      if (arr && arr.length >= this.limit) {
        this.mobUploadVisible = false;
      }
    },
  },
  data() {
    return {
      env: process.env,
      fileList: [],
      loading: null,
      dialogVisible: false,
      dialogImageUrl: "",
      mobUploadVisible: false,
    };
  },
  created() {
    this.fileList = this.list.map((item) => ({
      name: item,
      url: item,
    }));
  },
  methods: {
    isVideo,
    // 上传图片之前
    uploadBefore(file) {
      const { size, type } = file;
      const isVerify = /(png|jpg|jpeg|mp4|webm|ogv)$/.test(type);
      let isLt = size / 1024 / 1024 < 2;
      if (/(mp4|webm|ogv)$/.test(type)) {
        isLt = size / 1024 / 1024 < 50;
      }

      if (!isVerify) {
        this.$message.error("上传必须是JPG/JPEG/PNG/MP4/WEBM/OGV格式");
      } else if (!isLt) {
        this.$message.error("存在超过2M的图片或50M的视频，请重新上传");
      }

      if (isVerify && isLt) {
        this.loading = this.$loading({
          lock: true,
        });
      }
      return isVerify && isLt;
    },
    // 上传图片成功之后
    uploadSuccess(res) {
      console.log("上传图片成功之后", res);
      const {
        data: { name, url },
      } = res;
      const item = {
        name: name || "",
        url: url || "",
      };
      this.loading && this.loading.close();
      this.fileList.push(item);
      const list = this.fileList.map((item) => item.url);
      this.$emit("update:list", list);
    },
    // 删除图片
    del(index) {
      this.fileList.splice(index, 1);
      const list = this.fileList.map((item) => item.url);
      this.$emit("update:list", list);
    },
    // 图片预览
    imgPreview(url) {
      this.dialogImageUrl = url;
      this.dialogVisible = true;
    },
    // 视频预览
    videoPreview(url) {
      window.open(url);
    },
    // 禁用状态下预览
    disabledPreview(url) {
      if (!this.disabled) {
        return;
      }
      if (isVideo(url)) {
        this.videoPreview(url);
      } else {
        this.imgPreview(url);
      }
    },
    // 手机上传
    mobUpload() {
      this.mobUploadVisible = true;
      const { limit, uploadId } = this;
      setTimeout(() => {
        QrCode.toCanvas(this.$refs.qrCodeCanvas, `${process.env.VUE_APP_static}imgTransfer/index2.html?t=${new Date().getTime()}&uuid=${uploadId}`);
      }, 100);

      imgTransferTimer && clearInterval(imgTransferTimer);
      imgTransferTimer = setInterval(async () => {
        const { data } = await requestApi.post(`${process.env.VUE_APP_APITAAS}scbasic/system/redis/sel`, {
          key: uploadId,
        });
        if (this.fileList && this.fileList.length >= limit) {
          clearInterval(imgTransferTimer);
          this.$message.warning("已达上传最大量");
          return;
        }
        data.valList.forEach((url) => {
          if (!this.fileList.some((item) => item.url == url)) {
            this.fileList.push({
              name: url.substring(0, url.lastIndexOf(".")),
              url,
            });
            const list = this.fileList.map((item) => item.url);
            this.$emit("update:list", list);
          }
        });
      }, 2000);
    },
  },
};
